module.exports = __webpack_public_path__ + "static/media/baekseokculture.1140b94a.png";